import React from 'react';

// Quarantine boundary for the Civic identity module.
//
// Civic's UMD bundle and MetaMask's SES lockdown have clashed once
// already (TypeError: Q is not a function). When that happens inside a
// React tree, the default behaviour is to unmount the whole branch —
// which on /global means the Pledge CTA disappears and the citizen
// sees a black screen. This boundary traps the error at the Civic
// wrapper so the rest of the page keeps rendering.

interface Props {
  fallback: React.ReactNode;
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export default class IdentityErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(_err: Error): State {
    return { hasError: true };
  }

  componentDidCatch(err: Error, info: React.ErrorInfo): void {
    console.warn('[IdentityErrorBoundary]', err, info.componentStack);
  }

  render(): React.ReactNode {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
